import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../../context/cartContext";
import "../../styles/luxury-product.css";
import { currencyFormatter, getMediaUrl } from "../../utils/site";
import { AuthContext } from "../../context/authContext";
import brandLogo from "../../assets/logo.png";

const ProductItem = ({ item }) => {
  const {
    id,
    uuid,
    image_url,
    image,
    name,
    price,
    material,
    weight,
    size,
    stock_quantity,
    status,
    category,
  } = item;

  const { addItem } = useCart();
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleAddToCart = () => {
    if (!user) {
      navigate("/login");
      return;
    }

    addItem(item, 1);
  };

  const imageSrc = getMediaUrl(image_url || image);
  
  // Stock status
  const stockNum = Number(stock_quantity);
  const isInStock = stockNum > 0;
  const isLowStock = stockNum > 0 && stockNum <= 5;

  return (
    <div className="luxury-product-card">
      <div className="luxury-product-image-wrapper">
        <img src={brandLogo} alt="Roha Jewellery watermark" className="roha-product-watermark" />
        
        {/* Stock Badge */}
        {isLowStock && (
          <span className="luxury-product-badge">Limited Stock</span>
        )}
        
        <img
          src={imageSrc}
          alt={name || "Product"}
          className="luxury-product-img"
          loading="lazy"
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = "/image.jpg";
          }}
        />
      </div>

      <div className="luxury-product-body">
        <div className="luxury-product-meta">
          <span className="luxury-product-eyebrow">
            {category || "Premium Piece"}
          </span>
          <h3 className="luxury-product-title">{name}</h3>
        </div>

        <p className="luxury-product-price">
          {currencyFormatter.format(Number(price || 0))}
        </p>

        <p className="luxury-product-details">
          {material && `${material}`}
          {weight && ` • ${weight}g`}
          {size && ` • ${size}`}
          <br />
          <span style={{ color: isInStock ? '#27a86e' : '#c86464' }}>
            {isInStock ? `${stockNum} in stock` : 'Out of stock'}
          </span>
        </p>

        <div className="luxury-product-actions">
          <button
            type="button"
            className="luxury-product-btn luxury-primary-btn"
            onClick={handleAddToCart}
            disabled={!isInStock}
            style={{ opacity: isInStock ? 1 : 0.5, cursor: isInStock ? 'pointer' : 'not-allowed' }}
          >
            {isInStock ? 'Add to Cart' : 'Out of Stock'}
          </button>

          <Link
            to={`/products/${uuid || id}`}
            className="luxury-product-btn luxury-secondary-btn"
          >
            View Details
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ProductItem;
